<template>
  <div class="mod-extra-validate clearfix" :style="fullStyle">
    <div class="validate-box-container">
      <div class="validate-box clearfix">
        <div class="head">自选产品购买</div>
        <div class="content">
          <add-passenger ref="verify" @subbmit="handleOk"></add-passenger>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import './index'
import Storage from '@/assets/js/storage'
import { validate } from '@/apis/extra'

export default {
  data () {
    return {
      fullStyle: ''
    }
  },
  async created () {
    const data = await window.__MICRO_ROOT__?.cms?.getPageData() || {}
    this.fullStyle = data.config?.fullStyle
  },
  methods: {
    handleOk (values) {
      this.visible = false
      const { certificateNo: certNo, ticketNo, name: passengerName, phone, flightDate } = values
      const params = {
        certNo,
        ticketNo,
        passengerName,
        phone,
        flightDate,
        slideCaptcha: new Date().getTime()
      }
      this.validate(params)
    },
    async validate (params) {
      try {
        const result = await validate(params) || []
        if (result.length) {
          const passenger = {
            passengerName: result[0].passengerName,
            certNo: result[0].certNo,
            phone: params.phone,
            itinerarys: result
          }
          try {
            Storage.setItem('extraItinerarys', JSON.stringify(passenger), 24 * 3600000)
          } catch (e) {
            this.$message.error('您的浏览器开启了无痕浏览模式，部分功能将无法使用，请关闭无痕浏览模式。')
          }
          this.$router.push({ path: '/extraalone/book' })
        } else {
          this.$refs.verify.reloadVerify()
          this.$message.error('验证信息有误！')
        }
      } catch (e) {
        this.$refs.verify.reloadVerify()
        this.$message.error(e.message || '网络异常，请稍后再试！')
      }
    }
  }
}
</script>
